export const state = () => ({
  step: null,
  color: true,
  ktp: false,
  avatar: false
})

export const mutations = {
  NEXT_STEP: (state) => {
    state.step++
  },
  SET_PHOTO_TYPE: (state, data) => {
    if (data === 'KTP') {
      state.ktp = true
    } else {
      state.avatar = true
    }
  },
  PREV_STEP: (state, data) => {
    if (state.step > 1) { state.step-- }
  },
  SET_STEP: (state, data) => {
    state.step = data
  },
  SET_COLOR: (state, data) => {
    if (data === 'female') {
      state.color = false
    } else {
      state.color = true
    }
  }
}
export const actions = {
  nextStep ({ commit }, body) {
    return new Promise((resolve, reject) => {
      this.$scrollTo('.containerFullHeight')

      commit('NEXT_STEP')
    })
  },
  getSuggestion ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('FullName', data.Fullname)

      this.$axios.post(process.env.BASE_API + 'doctor/pending/suggestion/username', formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  sendStepOne ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('Fullname', data.Fullname)
      formData.append('Specialist', data.Specialist)
      formData.append('University', data.University)
      formData.append('YearGraduated', data.YearGraduate)
      formData.append('Address', data.Address)
      formData.append('Gender', data.Gender)
      formData.append('PhoneOffice', data.PhoneOffice)
      formData.append('MaritalStatus', data.MaritalStatus)
      formData.append('Birthdate', data.Birthdate)
      formData.append('Status', data.Status)
      formData.append('PersonalUrl', data.PersonalUrl)

      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/update`, formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  sendStepTwo ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('NoSTR', data.NoSTR)
      if (data.FileSTR) {
        formData.append('FileSTR', data.FileSTR)
      }
      formData.append('NoSIP', data.NoSIP)
      if (data.FileSIP) {
        formData.append('FileSIP', data.FileSIP)
      }
      formData.append('NoIDI', data.NoIDI)
      if (data.FileIDI) {
        formData.append('FileIDI', data.FileIDI)
      }
      formData.append('NoSpecialistCertificate', data.NoSpecialistCertificate)
      if (data.FileSpecialistCertificate) {
        formData.append('FileSpecialistCertificate', data.FileSpecialistCertificate)
      }
      formData.append('NoCertificateCompetency', data.NoCertificateCompetency)
      if (data.FileCertificateCompetency) {
        formData.append('FileCertificateCompetency', data.FileCertificateCompetency)
      }
      if (data.AdditionalFiles) {
        formData.append('AdditionalFiles', data.AdditionalFiles)
      }
      if (data.ExpiredSIP) {
        formData.append('ExpiredSIP', data.ExpiredSIP)
      }
      if (data.ExpiredSTR) {
        formData.append('ExpiredSTR', data.ExpiredSTR)
      }
      if (data.ExpiredCOM) {
        formData.append('ExpiredCOM', data.ExpiredCOM)
      }

      formData.append('Status', data.Status)

      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/update`, formData, { timeout: 0 })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  sendStepThree ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('Bank', data.Bank)
      formData.append('BankID', data.BankID)
      formData.append('BankNumber', data.BankNumber)
      formData.append('BankName', data.BankName)
      if (data.NoNPWP) {
        formData.append('NoNPWP', data.NoNPWP)
      }
      if (data.NPWPAddress) {
        formData.append('NPWPAddress', data.NPWPAddress)
      }
      if (data.NPWPName) {
        formData.append('NPWPName', data.NPWPName)
      }
      if (data.Dependents) {
        formData.append('Dependents', data.Dependents)
      }

      if (data.BankCityID) {
        formData.append('BankCityID', data.BankCityID)
      }
      formData.append('Status', 'BANK_INFO')
      formData.append('FlagNPWP', data.FlagNPWP)

      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/update`, formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  sendStepFour ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('Status', 'ESIGNATURE')
      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/update`, formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  checkPersonalUrl ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('PersonalUrl', data)
      this.$axios.post(process.env.BASE_API + 'doctor/pending/check/url', formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  sendStepAdditional ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('Esignature', data.file)
      formData.append('Status', 'BANK_INFO')
      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/update`, formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  editDataUser ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('Status', `${data.status}`)
      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/update`, formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getBankCities ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `cities?q=${data}`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  registrationStatus ({ commit }, data) {
    const { email, token, fromEmail } = data
    return new Promise((resolve, reject) => {
      let link = ''
      if (fromEmail) {
        link = `doctor/verification/check/?email=${email}&token=${token}&fromEmail=${fromEmail}`
      } else {
        link = `doctor/verification/check/?email=${email}&token=${token}`
      }
      if (email) {
        this.$axios.get(process.env.BASE_API + `${link}`, {
          headers: {
            DeviceType: 'web'
          }
        })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      }
    })
  },
  adminStatus ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `doctor/admin/${data.id}/verify/email/${data.token}`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getPendingData ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `doctor/pending/${data.id}`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  sendPhoto ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      let fileType = 'KTP'
      if (data.type === 'avatar' || data.type === 'ktp') {
        if (data.type === 'avatar') {
          fileType = 'Avatar'
          formData.append('Avatar', data.content)
        } else {
          formData.append('KTP', data.content)
        }
      } else {
        if (data.FileSTR) {
          formData.append('FileSTR', data.FileSTR)
        }
        if (data.FileSIP) {
          formData.append('FileSIP', data.FileSIP)
        }
        if (data.FileIDI) {
          formData.append('FileIDI', data.FileIDI)
        }
        if (data.FileSpecialistCertificate) {
          formData.append('FileSpecialistCertificate', data.FileSpecialistCertificate)
        }
        if (data.FileCertificateCompetency) {
          formData.append('FileCertificateCompetency', data.FileCertificateCompetency)
        }
        if (data.Additional) {
          formData.append('Additional', data.Additional)
          formData.append('Key', data.Key)
        }
        if (data.Additional === null) {
          formData.append('Key', data.Key)
        }
        if (data.FileNPWP) {
          formData.append('FileNPWP', data.FileNPWP)
          formData.append('FlagNPWP', data.FlagNPWP)
        } else if (data.type) {
          if (data.type === 'NPWP') {
            formData.append('FlagNPWP', data.FlagNPWP)
          }
        }
      }

      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/upload/document`, formData, {
        headers: {
          DeviceType: 'web'
        },
        cancelToken: data.tokenAccess
      })
        .then(function (response) {
          if (fileType === 'KTP' || fileType === 'Avatar') {
            if (data.content) {
              commit('SET_PHOTO_TYPE', fileType)
            }
          }
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  cancelData ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const CancelToken = this.$axios.CancelToken
      const source = CancelToken.source()

      this.$axios.post(process.env.BASE_API + `doctor/pending/${data.id}/upload/document`, {}, {
        cancelToken: source.token
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })

      source.cancel('Operation canceled by the user.')
    })
  },
  getListSpecialist () {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + 'doctor/types')
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getBankData () {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + 'doctor/list/bank')
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
